<template>
    <Frame>
        <PageHeader :title="$t('comm.stockRemainQuery')" :hasBack="false" />
        <div class="list-contain">
            <div class="head-contain">
                <div class="filter-contain" style="width: 16%;">
                    <span>{{ $t('StockRemainQuery.supplier') }}：</span>
                    <el-input v-model="supplier" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>
                
                <div class="filter-contain" style="width: 16%;">
                    <span>{{ $t('StockRemainQuery.basZip') }}：</span>
                    <el-input v-model="basZip" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>ItemCode：</span>
                    <el-input v-model="materialId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>ItemName：</span>
                    <el-input v-model="materialName" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('StockRemainQuery.materialSpec') }}：</span>
                    <el-input v-model="materialSpec" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain" style="width: 16%;">
                    <span style="min-width: 56px;">{{ $t('StockRemainQuery.length') }}：</span>
                    <el-input v-model="length" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain" style="width: 16%;">
                    <span style="min-width: 70px;">{{ $t('StockRemainQuery.color') }}：</span>
                    <el-input v-model="color" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div style="padding-right: 1%;"> 
                    <span style="width: 100%;display: flex; ">
                        <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                        <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
                    </span>
                </div>

                <span style="color:red;font-size: 14px;font-weight: bold;height: 42px;line-height: 36px;">{{ $t('StockRemainQuery.warnText') }}</span>
            </div>
        </div>
        <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
             @select-all="handleSelectAll" @select="handleSelect" v-loading="tableLoading">
            <el-table-column type="selection" fixed></el-table-column>
            <el-table-column :width="WidthControl('X_BPMaterialId',tableData)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BPMaterialName',tableData)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
            <el-table-column :min-width="WidthControl('X_Addr',tableData)" prop="X_Addr" :label="$t('StockRemainQuery.wareHouseAddress')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_ColorId',tableData,3)" prop="X_ColorId" :label="$t('StockRemainQuery.color')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_Length',tableData,2)" prop="X_Length" align="right" :label="$t('StockRemainQuery.length')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_LUnitId',tableData,4)" prop="X_LUnitId" :label="$t('StockRemainQuery.lengthUnit')"></el-table-column>
            <el-table-column :min-width="WidthControl('Quantity',tableData,4)" prop="Quantity" :label="$t('StockRemainQuery.numberId')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BizPartnerName',tableData)" prop="X_BizPartnerName" :label="$t('StockRemainQuery.supplier')"></el-table-column>
            <el-table-column width="140" :label="$t('StockRemainQuery.orderNum')">
                <template slot-scope="scope">
                    <el-input-number v-model="scope.row.orderNum" :min="0" size="small" @change="OrderNumChange(scope.$index,scope.row)"></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <div class="footer-contain">
            <div class="btnarray">
                <el-button type="primary" @click="OrderConfirm()" :title="$t('StockRemainQuery.orderConfirm')">{{orderBtn}}</el-button>
            </div>
            <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
            <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange"
                layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage"
                :total="totalCount" :page-size="pageSize"></el-pagination>
        </div>
        <OrderConfirmDialog ref="OrderConfirmDialog" @order-item="handleOrderFromDialog"></OrderConfirmDialog>
    </Frame>
</template>
<script>
import { listMixin } from "@/agency/mixin/mixin.js";
import { addOrRemoveInSelectData } from '@/utils/utils.js'
import OrderConfirmDialog from '@/components/OrderConfirmDialog.vue';
export default {
    name: "StockRemainQuery",
    mixins: [listMixin],
    components:{
        OrderConfirmDialog
    },
    data() {
        return {
            materialId:'',
            materialName:'',
            materialSpec:'',
            color:'',
            length:'',
            supplier:'',
            basZip:'',
            tableHeight: window.innerHeight - 300,
            pagecount: 5,
            selectData: [],
            orderData: [],
            orderBtn:this.$t('StockRemainQuery.orderBtn').format(0)
        };
    },
    props: {
        GetListData: {
            type: Function,
            default: function (pageIndex, ...arg) {
                this.getListData(pageIndex, ...arg);
            }
        }
    },
    mounted() {
        this.frameOnResize(300);
    },
    methods: {
        OrderNumChange(index,row){
            let selected=false;
            if(row.orderNum>0) selected=true;
            this.$refs.multipleTable.toggleRowSelection(row,selected);
            this.selectData = addOrRemoveInSelectData([row],this.selectData,selected,"RowNo");
            this.orderBtn=this.$t('StockRemainQuery.orderBtn').format(this.selectData.length);
        },
        handleSelectAll(val) {
            if(val.length>0){
                val.forEach((row)=>{
                    if(row.orderNum==0){
                        row.orderNum=1;
                    }
                })
                this.selectData = addOrRemoveInSelectData(val,this.selectData,true,"RowNo");
            }else{
                this.tableData.forEach((row)=>{
                    row.orderNum=0;
                })
                this.selectData = addOrRemoveInSelectData(this.tableData,this.selectData,false,"RowNo");
            }
            this.orderBtn=this.$t('StockRemainQuery.orderBtn').format(this.selectData.length);
        },
        handleSelect(val, row){
            let rowNo = val.indexOf(row);
            if (rowNo==-1) {
                row["orderNum"]=0;
                this.selectData = addOrRemoveInSelectData([row],this.selectData,false,"RowNo");
            } else {
                row["orderNum"]=1;
                this.selectData = addOrRemoveInSelectData([row],this.selectData,true,"RowNo");
            }
            this.orderBtn=this.$t('StockRemainQuery.orderBtn').format(this.selectData.length);
        },
        getListData(index) {
            if (this.materialId==""&&this.materialName==""&&this.materialSpec==""&&this.basZip=="") { 
                this.$alert(this.$t("StockRemainQuery.queryWarn"), this.$t("comm.tip"));
                return;
            }
            this.pageIndex = index;
            this.tableLoading = true;
            this.axiosInvoke(
                this.YMBillHandlerUrl,
                {
                    action: "stockremainquery", 
                    materialId:this.materialId,
                    materialName:this.materialName,
                    materialSpec:this.materialSpec,
                    basZip:this.basZip,
                    color:this.color,
                    length:this.length,
                    supplier:this.supplier,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                },
                res => {
                    const data = res.data;
                    this.tableLoading = false;
                    this.tableData = data.DataTable;
                    this.$nextTick(()=>{
                        this.tableData.forEach((row)=>{
                            this.selectData.forEach((selectRow)=>{
                                if(row.RowNo==selectRow.RowNo){
                                    this.$refs.multipleTable.toggleRowSelection(row,true);
                                    row.orderNum=selectRow.orderNum;
                                    selectRow =row;
                                }
                            })
                        })
                    })
                    this.totalCount = data.totalCount;
                },
                false,
                true
            );
        },
        reset() {
            this.baseReset();
            this.materialId='';
            this.materialName='';
            this.materialSpec='';
            this.color='';
            this.length='';
            this.supplier='';
            this.basZip='';
            this.orderData= [];
        },
        pageSizeChange() {
            this.GetListData(0);
        },
        OrderConfirm(){
            let table=this.selectData;
            if(table.length==0){
                this.$alert(this.$t("comm.unselectwarning"), this.$t("comm.tip"));
                return;
            }
            this.$refs.OrderConfirmDialog.GetOrderConfirmList(table);
        },
        handleOrderFromDialog(table){
            table.forEach((row)=>{
                this.selectData.forEach((selectRow)=>{
                    if(selectRow.RowNo==row.RowNo){
                        this.selectData = addOrRemoveInSelectData([selectRow],this.selectData,false,"RowNo");
                        this.tableData.forEach((curRow)=>{
                            if(row.RowNo==curRow.RowNo){
                                curRow.orderNum=0;
                                this.$refs.multipleTable.toggleRowSelection(curRow,false);
                            }
                        })
                    }
                })
            })
            this.orderBtn=this.$t('StockRemainQuery.orderBtn').format(this.selectData.length);
        },
        handleCurrentChange(page) {
            this.pageIndex = page - 1;
            this.GetListData(this.pageIndex);
        }
    }
};
</script>
<style scoped>
.list-contain {
    display: flex;
    padding: 10px 0px;
}

.head-contain {
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.el-input {
  padding-left: 5px;
}

.filter-contain {
    width: 21%;
    padding-right: 1%;
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 10px;
}

.filter-contain>span {
    color: black;
    font-size: 14px;
    margin: auto;
    white-space: nowrap;
}

.head-contain > div >span > .el-button{
  padding: 10px 18px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-table{
  font-size: 12px;
  color: black;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
    padding-left: 5px;
}

.footer-contain {
    display: flex;
    padding-top: 6px;
}

.pagination {
    padding-top: 4px;
}

.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}

.el-table /deep/ thead {
    font-size: 14px;
    color: black;
}
.btnarray {
  width: 40%;
  margin-left: 7px;
}
.el-button--primary{
  padding: 6px 18px;
}
</style>
